import React from 'react';
import './web-tag-error-styles.css';

export const WebTagError = ( { title, error } ) => {
    return (
        <div className="step">
            <div className="step-container">
                <h3 className="title title-error">{ title }</h3>
                <p>{ error }</p>
            </div>
        </div>
    );
}
